import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="dp-footer">
        <div className="dp-footer-container">
          <div className="dp-footer-grid">
            {/* Brand Section */}
            <div className="dp-footer-brand">
              <Link to="/" className="dp-footer-logo">
                <img
                  src={require("../../../../assets/images/dream-prize.jpeg").default}
                  alt="DreamPrize"
                />
              </Link>
              <p className="dp-footer-tagline">
                Your gateway to exciting prizes and amazing rewards. Join thousands of winners today!
              </p>
              <div className="dp-footer-social">
                <a href="#" className="dp-social-link" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="dp-social-link" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="dp-social-link" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="dp-social-link" aria-label="YouTube">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="dp-footer-column">
              <h4>Quick Links</h4>
              <ul className="dp-footer-links">
                <li>
                  <Link to="/">
                    <i className="fas fa-chevron-right"></i>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/products">
                    <i className="fas fa-chevron-right"></i>
                    Products
                  </Link>
                </li>
                <li>
                  <Link to="/draws">
                    <i className="fas fa-chevron-right"></i>
                    Draws
                  </Link>
                </li>
                <li>
                  <Link to="/winner-list">
                    <i className="fas fa-chevron-right"></i>
                    Winners
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="dp-footer-column">
              <h4>Company</h4>
              <ul className="dp-footer-links">
                <li>
                  <Link to="/about">
                    <i className="fas fa-chevron-right"></i>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact">
                    <i className="fas fa-chevron-right"></i>
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy">
                    <i className="fas fa-chevron-right"></i>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/user-agreement">
                    <i className="fas fa-chevron-right"></i>
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="dp-footer-column">
              <h4>Contact Us</h4>
              <div className="dp-footer-contact">
                <div className="dp-contact-item">
                  <div className="dp-contact-icon">
                    <i className="far fa-envelope"></i>
                  </div>
                  <div className="dp-contact-text">
                    <span>Email</span>
                    <a href="mailto:support@dreamprize.com">support@dreamprize.com</a>
                  </div>
                </div>
                <div className="dp-contact-item">
                  <div className="dp-contact-icon">
                    <i className="far fa-clock"></i>
                  </div>
                  <div className="dp-contact-text">
                    <span>Support Hours</span>
                    <p>Mon - Fri: 9AM - 6PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="dp-footer-bottom">
            <div className="dp-footer-bottom-inner">
              <p className="dp-copyright">
                © {new Date().getFullYear()} <Link to="/">DreamPrize</Link>. All rights reserved.
              </p>
              <div className="dp-footer-bottom-links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/user-agreement">Terms of Use</Link>
                <Link to="/about">About Us</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Back to Top Button */}
      <button
        className={`dp-back-to-top ${showBackToTop ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <i className="far fa-arrow-up"></i>
      </button>
    </>
  );
}

export default Footer;
